/**
 * Pure helpers for Platform Mailgun settings form save + webhook signing key UX.
 * Secrets must never be hydrated from server responses into these helpers.
 */

export function buildPlatformMailgunSavePayload(formData = {}) {
  const payload = { ...formData };

  if (!String(payload.api_key || '').trim()) {
    delete payload.api_key;
  } else {
    payload.api_key = String(payload.api_key).trim();
  }

  // Blank means "preserve existing encrypted key" — omit from POST.
  if (!String(payload.webhook_signing_key || '').trim()) {
    delete payload.webhook_signing_key;
  } else {
    payload.webhook_signing_key = String(payload.webhook_signing_key).trim();
  }

  return payload;
}

/**
 * Resolve whether a webhook signing key is already configured.
 * Prefer settings.webhook_signing_key_configured when present; fall back to
 * /webhooks/mailgun/config-status signing_key_configured; allow optimistic
 * local flag after a successful save.
 */
export function resolveWebhookSigningKeyConfigured({
  settings = null,
  configStatus = null,
  localConfiguredAfterSave = false,
} = {}) {
  if (localConfiguredAfterSave) return true;
  if (settings?.webhook_signing_key_configured === true) return true;
  if (configStatus?.signing_key_configured === true) return true;
  return false;
}

export function createEmptyMailgunFormFields(overrides = {}) {
  const {
    api_key: _ignoredApiKey,
    webhook_signing_key: _ignoredSigningKey,
    ...safeOverrides
  } = overrides || {};

  return {
    mailgun_domain: '',
    from_name: '',
    from_email: '',
    reply_to_email: '',
    region: 'US',
    is_active: false,
    use_as_platform_default: true,
    use_as_agency_fallback: true,
    track_opens: true,
    track_clicks: true,
    enable_unsubscribe_tracking: false,
    enable_bounce_logging: true,
    environment: 'production',
    ...safeOverrides,
    // Always blank — never copy decrypted secrets into form state.
    api_key: '',
    webhook_signing_key: '',
  };
}
